import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";

export const Layout = () => {
  return (
    <Box>
      <Outlet />
    </Box>
  );
};
